// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__B_1SA","imageWrapper":"styles_imageWrapper__6E_GH","loader":"styles_loader__eXerr"};